<ngb-alert [ngClass]="customClass" [type]="alertSettings.class" [dismissible]="false">
    {{alertSettings.message}}
</ngb-alert>